
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Beneficio</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitBenefir(benefitGroupForm)" #benefitGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="benefit.description" [(ngModel)]="benefit.description">
								<mat-error>{{ violations['benefit.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="benefit.attribute" [(ngModel)]="benefit.attribute" (keydown.space)="$event.preventDefault()">
								<mat-error>{{ violations['benefit.attribute'] }}</mat-error>
							</mat-form-field>
						</div>
                        <div class="control">
                            <mat-form-field class="controlWidth">
                              <mat-label>Tipo Beneficio</mat-label>
                              <mat-select [(ngModel)]="benefit.benefitType"  [compareWith]="compareBenefitTypes" name="benefit.benefitType" >
                              @for (benefitType of benefitTypes ; track benefitType.id) {
                                <mat-option [value]="benefitType">{{ benefitType.description }}</mat-option>
                              }
                            </mat-select>
							<mat-error>{{ violations['benefit.benefitType'] }}</mat-error>
							<mat-error *ngIf="violations['benefit.benefitType']">
								{{ violations['benefit.benefitType'] }}
							  </mat-error>
                            </mat-form-field>
                        </div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="benefit.active"  name="benefitActive" > 
							  {{ benefit.active? 'Beneficio Activo':'Beneficio Inactivo'}} 
							</mat-slide-toggle>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(benefit.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>